module.exports = __webpack_public_path__ + "img/borussia2.86f8f182.jpg";